export default __webpack_public_path__ + "static/Bitrate_Test_12_h264_hp_320000-17850aa3fee4c44fca6f2b232257bbe3.avif";